import React, {Component} from 'react';
import Reveal from 'react-reveal/Reveal';
import {Link} from 'react-router-dom';

class FooterErp extends Component {

    render() {
        let{fClass} = this.props;

        const d = new Date();
        let year = d.getFullYear();

        return(
            <footer id="section_contact" className={`footer_area h_footer_dark ${fClass}`}>
                <div className="container">
                    <div className="row">

                        <Reveal effect="fadeInLeft" duration={500} key={1}>
                            <div className="col-lg-4 col-sm-6" >
                                <div className="f_widget dark_widget company_widget" data-wow-delay="0.2s">
                                    <a href="index.html" className="f-logo"><img src={require ("../../img/logo2.png")} alt=""/></a>
                                    <p>© {year} joobster gmbh<br/>Proudly created in Linz/Austria</p>
                                    <p>
                                    hello@joobster.at<br/>
                                    Zentastraße 6/9<br/>
                                    4061 Pasching
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                        
                        <Reveal effect="fadeInLeft" duration={500} key={2}>
                            <div className="col-lg-3 col-sm-12"></div>
                        </Reveal>
                        
                        <Reveal effect="fadeInLeft" duration={500} key={3}>
                            <div className="col-lg-3 col-sm-12"></div>
                        </Reveal>

                        <Reveal effect="fadeInLeft" duration={500} key={4}>
                            <div className="col-lg-2 col-sm-12">
                                <div className="f_widget dark_widget about-widget pl_70">
                                    <h3 className="f-title f_500 t_color f_size_18 mb_40">Service</h3>
                                    <ul className="list-unstyled f_list">

                                         <li key="serv_1"><Link to="/impressum">Impressum</Link></li>
                                         <li key="serv_2"><Link to="/datenschutz">Datenschutz</Link></li>
                                         <li key="serv_3"><Link to="/credits">Credits</Link></li>
                                         
                                    </ul>
                                   
                                </div>
                            </div>
                        </Reveal>

                    </div>
                </div>
            </footer>
        )
    }
}
export default FooterErp;


/*

{
                            FooterData.AboutWidget.map(widget=>{
                                return(
                                    <Reveal effect="fadeInLeft" duration={500} key={widget.id}>
                                    <div className="col-lg-3 col-sm-6">
                                        <div className="f_widget dark_widget about-widget pl_70">
                                            <h3 className="f-title f_500 t_color f_size_18 mb_40">{widget.title}</h3>
                                            <ul className="list-unstyled f_list">
                                                {
                                                    widget.menuItems.map(item =>{
                                                        return(
                                                            <li key={item.id}><Link to="/">{item.text}</Link></li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    </Reveal>
                                )
                            })
                        }
                        {
                            FooterData.termsCondition.map(widget=>{
                                return(
                                    <Reveal effect="fadeInLeft" duration={500} key={widget.id}>
                                    <div className="col-lg-2 col-sm-6">
                                        <div className="f_widget dark_widget about-widget">
                                            <h3 className="f-title f_500 t_color f_size_18 mb_40">{widget.title}</h3>
                                            <ul className="list-unstyled f_list">
                                                {
                                                    widget.menuItems.map(item =>{
                                                        return(
                                                            <li key={item.id}><Link to="/">{item.text}</Link></li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    </Reveal>
                                )
                            })
                        }

*/